import { Select, SelectProps, Tag } from 'antd';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';
import styled, { css } from 'styled-components';

import Icon from '@ant-design/icons';

export const DimensionSelect = styled(Select)<
  SelectProps<any, BaseOptionType | DefaultOptionType> & { showLeftBorder?: boolean }
>`
  .emp-ant-select .emp-ant-select-in-form-item {
    width: fit-content !important;
  }
  &&.emp-ant-select {
    max-width: fit-content;
    width: fit-content !important;
    display: inline-flex;
    flex: 1;
    height: auto;

    .emp-ant-select-selector {
      background: #f5f5f5 !important;
      border-radius: 2px;
      padding: 0 8px 0 12px;
      align-items: center;
      height: auto;

      .emp-ant-select-selection-item {
        height: fit-content;
      }

      .emp-ant-select-selection-placeholder {
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .emp-ant-select-arrow {
      color: rgba(0, 0, 0, 0.45);
    }

    &.emp-ant-select-disabled .emp-ant-select-selector .emp-ant-select-selection-item {
      color: rgba(0, 0, 0, 0.88);
    }
  }

  &.emp-ant-select:not(.emp-ant-select-focused):not(:hover) {
    .emp-ant-select-selector {
      border-right: 0;
      ${({ showLeftBorder = true }) => {
        if (!showLeftBorder) {
          return css`
            border-left: 0;
          `;
        }
        return;
      }}
    }
  }

  &.emp-ant-select.emp-ant-select-compact-item {
    margin-inline-end: 0;
  }

  &.emp-ant-select-disabled:hover {
    .emp-ant-select-selector {
      border-right: 0;
    }
  }
`;

export const DimensionValueSelect = styled(Select)<
  SelectProps<any, BaseOptionType | DefaultOptionType> & {
    showRightBorder?: boolean;
    minWidth?: string;
  }
>`
    &.emp-ant-select {
        display: inline-flex;
        flex: 1;
        min-width: 0;

        .emp-ant-select-selector {
            width: fit-content !important;
            min-width: ${({ minWidth }) => (minWidth ? minWidth : '83px')};
            border-radius: 2px;
            flex-grow: 1;

            .emp-ant-select-selection-placeholder {
                color: rgba(0, 0, 0, 0.25);
            }
        }
    }


    &:not(.emp-ant-select-focused):not(:hover) {
        .emp-ant-select-selector {
            border-left: 0;
            ${({ showRightBorder = true }) => {
              if (!showRightBorder) {
                return css`
                  border-right: 0;
                `;
              }
              return;
            }}
        }
    }
}

&.emp-ant-select-disabled:hover {
    .emp-ant-select-selector {
        border-left: 0;
    }
}

&.emp-ant-select-status-error {
    .emp-ant-select-selector {
        border-left: 1px solid #ff7875 !important;
    }
}
`;

export const StyledIcon = styled(Icon)`
  && {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding: 4px 8px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(217, 217, 217) rgb(217, 217, 217) rgb(217, 217, 217) transparent;
    border-image: initial;
    color: rgba(0, 0, 0, 0.45);
    background: rgb(240, 240, 240);
    cursor: pointer;
    border-radius: 0 2px 2px 0;
  }
`;

export const DimensionValueDropdownRenderWrapper = styled.div`
  // Hide the checkmark icon after each item
  .emp-ant-select-item-option .emp-ant-select-item-option-state {
    display: none;
  }
  // The count and text content of each item, aligned at both ends.
  .emp-ant-select-item-option-content label.emp-ant-checkbox-wrapper {
    & > span:nth-of-type(2) {
      flex: 1;
      min-width: 0;
    }
  }
`;

export const DimensionValueLabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  min-width: 0;

  & span.select-item-label-text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 16px;
  }
`;

export const StyledTag = styled(Tag)`
  &.emp-ant-tag {
    overflow: hidden;
    white-space: pre;
    text-overflow: ellipsis;
    background: rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(0, 0, 0, 0.06);
    font-size: 14px;
    line-height: 22px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;
